import React, { useRef } from 'react'
import { isSafariDesktop } from '../functions/browserChecks';

export default function VideoHelper(props) {

  const videoRef = useRef(null)


  const checkForGif = () => {
    if(props.videoSrc.includes('gif')) {
      return true;
    }

    return false;
  }

  if (!isSafariDesktop() && !checkForGif()) {
    return <video
        autoPlay={true}
        playsInline
        muted
        controls={false}
        ref={videoRef}
        key={props.videoSrc}
        className={props.className || 'videoPlayerHelper'}
        loop={props.loop}
        >
        <source src={props.videoSrc} type="video/mp4" />
      </video>
  } else {
    return <img className={props.className || 'videoPlayerHelper'} src={props.videoSrc} loop={props.loop} alt="Hello Spot"></img>
  }
}